import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { CompressorScheduleForecast } from '@repo/sdk/models/components';

import { useGaiaClient } from '@/hooks/use-gaia-client';
import { getCompressorScheduleForecastQuery } from '@/queries/gaia-api/get-compressor-schedule-forecast-query';
import { listEaiControlledDeviceIdsQuery } from '@/queries/gaia-api/scheduled-app';
import { GaiaQueryWithAgentId } from '@/queries/types';

export const useListEaiControlledDeviceIds = ({
  agentId,
}: GaiaQueryWithAgentId): UseQueryResult<string[] | undefined> => {
  const client = useGaiaClient();
  return useQuery(listEaiControlledDeviceIdsQuery({ agentId, client }));
};

interface UseGetCompressorScheduleForecastProps extends GaiaQueryWithAgentId {
  since: Date;
  until: Date;
}

export const useGetCompressorScheduleForecast = ({
  agentId,
  since,
  until,
}: UseGetCompressorScheduleForecastProps): UseQueryResult<
  CompressorScheduleForecast | undefined
> => {
  const client = useGaiaClient();
  return useQuery(getCompressorScheduleForecastQuery({ agentId, client, since, until }));
};
